import React, { useEffect, useState } from "react";
import { cn } from "../utils";
import { Skeleton } from "./Skeleton";
import { Spinner } from "./Spinner";

/** "· 3s" counter that appears once a load has run for 2s. */
function useElapsedSeconds() {
  const [elapsed, setElapsed] = useState(0);
  useEffect(() => {
    const start = Date.now();
    const id = setInterval(() => setElapsed((Date.now() - start) / 1000), 500);
    return () => clearInterval(id);
  }, []);
  return elapsed;
}

/**
 * Stands in for the pagination footer while a list loads. Same 52px height,
 * so the card does not jump when the real footer comes back.
 */
export function LoadingFooter({ label = "Loading", className }) {
  const elapsed = useElapsedSeconds();
  return (
    <div
      className={cn(
        "h-[52px] border-t border-gray-200 border-solid border-b-0 border-x-0 bg-gray-50 px-6 flex items-center justify-between gap-6",
        className
      )}
    >
      <div className="flex items-center gap-2 min-w-0">
        <Spinner />
        <span className="text-xs text-gray-700 truncate">{label}</span>
        {elapsed >= 2 && (
          <span className="text-[11px] text-gray-500 tabular-nums">
            · {Math.floor(elapsed)}s
          </span>
        )}
      </div>
      <Skeleton variant="line" width={120} />
    </div>
  );
}

export default LoadingFooter;
